<template>
  <ViewerLayoutRoot class="content-guest-layout" data-testid="content-guest-layout">
    <GuestTopBar compact-desktop-top-spacing />

    <div class="content-guest-layout__content">
      <ViewerContent />
      <div v-if="isMobile" class="px-4 pt-4 pb-1">
        <ItemName />
      </div>
      <div class="px-4 sm:px-0">
        <MetadataSection :show-toolbar="false" />
      </div>
    </div>

    <!-- Engagement Bar -->
    <div class="px-4 sm:px-0">
      <EngagementBar />
    </div>

    <!-- Tabs -->
    <div class="content-guest-layout__tabs px-4 sm:px-0">
      <ContentGuestTabs @addedComment="emit('addedComment')" />
    </div>
  </ViewerLayoutRoot>
</template>

<script setup lang="ts">
import ViewerContent from '@/modules/viewer/components/Content.vue';
import ItemName from '@/modules/viewer/components/Name.vue';
import { useMobileDetection } from '@/composables/useMobileDetection';
import GuestTopBar from '../../shared/GuestTopBar.vue';
import EngagementBar from '../../shared/EngagementBar.vue';
import MetadataSection from '../../shared/MetadataSection.vue';
import ContentGuestTabs from './ContentGuestTabs.vue';

import ViewerLayoutRoot from '../../shared/ViewerLayoutRoot.vue';

const { isMobile } = useMobileDetection();

const emit = defineEmits<{
  addedComment: [];
}>();
</script>

<style scoped>
.content-guest-layout__content {
  @apply flex flex-col min-w-0;
}

.content-guest-layout__tabs {
  @apply mt-2;
}
</style>
